<app-slide-in-modal size="lg" #modal>
  <ng-container title i18n>Nouvelle demande</ng-container>
  <div body>
    <!--
      Built when the form is opened, not when the page that hosts it is: the
      form reads the customer and all their policies on init, and this modal
      sits on pages that never open it.
    -->
    @if (modal.opened) {
      <app-lead-form
        [customerId]="customerId"
        [memberId]="memberId"
        [(isSubmitted)]="isSubmitted"
        (formSubmit)="saveLead($event)"
        [originalProposalId]="originalProposalId"
        [formId]="formId"
      />
    }
  </div>
  <div class="modal-submit-buttons" footer>
    <button
      type="button"
      class="lty-btn lty-btn-white ms-auto"
      (click)="closeModal()"
      i18n
    >
      Annuler
    </button>
    <button
      [attr.form]="formId"
      type="submit"
      [disabled]="!leadForm?.isValid() || isSubmitted"
      class="lty-btn lty-btn-primary"
      i18n
    >
      Ajouter
    </button>
  </div>
</app-slide-in-modal>
